import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import spinner from '../assign-prescriptions/images/spinner.gif';
import smallSpinner from '../assign-prescriptions/images/1.gif';
import { withTranslation } from "react-i18next";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
  {
   
  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, t } = this.props;
        const rows = [
            { id: "PrescriptionNumber", numeric: false, disablePadding: false, label: t("Patient.Medication.PrescriptionNumber"), padding: '2px' },
            { id: "DisplayName", numeric: false, disablePadding: false, label: t("Patient.Medication.DisplayName"), padding: '2px' },
            { id: "Ndc", numeric: false, disablePadding: false, label: t("Patient.Medication.NDCCode"), padding: '2px' },
            { id: "PrescriptionId", numeric: false, disablePadding: false, label: t("Patient.Medication.PrescriptionID"), padding: '2px' },
            { id: "FillID", numeric: false, disablePadding: false, label: t("Patient.Medication.FillID"), padding: '2px' },
            { id: "Quantity", numeric: false, disablePadding: false, label: t("Patient.Medication.Quantity"), padding: '2px' },
            { id: "Status", numeric: false, disablePadding: false, label: t("Patient.Medication.Status"), padding: '2px' },
        ];
        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: 500 }}
                            >
                                <Tooltip
                                    title={t("Global.Label.Filter.Sort")}
                                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = theme => ({
    root: {
        width: "100%",
    },
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    },
    padding10px: {
        padding: '2px !important',
        width: '50px'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    },
    primaryButton: {
        background: '#6cca98',
        color: '#fff',
        '&:hover': {
            background: '#6cca98',
            color: '#fff',
        },
        '&:disabled': {
            color: 'rgba(0, 0, 0, 0.38)',
            cursor: 'not-allowed',
            background: '#E4E5E8'
        }
    }
});

let TransactionFilterObj = {
    searchtext: ''
}

class PatientMadicationHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: "desc",
            dob: '',
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            isOpen: false,
            loader: false,
            selectedObject: null,
            isDataEmpty: true,
            error: '',
            isSyncInProgress: false
        };
    }

    componentDidMount() {
        this.BindGrid();
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.orderBy === property && this.state.order === "desc") {
            order = "asc";
        }
        this.setState({ order, orderBy });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    onSearchChange = (event) => {
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        TransactionFilterObj.searchtext = searchString;
        this.BindGrid();
    }

    BindGrid() {
        const { parent_account_id, patient_id } = this.props && this.props.patient;
        fetch(process.env.REACT_APP_BASEURL + `patient/madication/history?patient_id=${patient_id}&account_id=${parent_account_id}`, {
            method: 'get',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            try {
                return response.json();
            } catch (error) {
                this.setState({ loader: false });
                return null;
            }
        }).then(data => {
            if (data && data.error) {
                this.setState({ error: data && data.error });
            } else {
                this.setState({ alllocations: data, boxDetails: data, Locations: data, loader: false });
            }
        }).catch((error) => {
            console.log(`Error while fetching madication history ${JSON.stringify(error)}`);
        });
    }

    syncWithThirdParty = () => {
        const { parent_account_id, patient_id } = this.props && this.props.patient;
        this.setState({ isSyncInProgress: true, error: '' });
        fetch(process.env.REACT_APP_BASEURL + `patient/madication/sync/history/by/patient?patient_id=${patient_id}&account_id=${parent_account_id}`, {
            method: 'get',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            }
        }).then(response => {
            try {
                return response.json();
            } catch (error) {
                this.setState({ loader: false });
                return null;
            }
        }).then(data => {
            if (data && data.error) {
                this.setState({ error: data && data.error, isSyncInProgress: false });
            } else {
                this.setState({ alllocations: data, boxDetails: data, Locations: data, loader: false });
            }
        }).catch((error) => {
            this.setState({ isSyncInProgress: false });
            console.log(`Error while fetching madication history ${error}`);
        });
    }

    render() {
        const { classes, t } = this.props;
        const { data, order, orderBy, rowsPerPage, page, error, isSyncInProgress } = this.state;
        return (
            <div>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> : (<div></div>)
                }
                <div>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={4} style={{ paddingLeft: '0rem' }}>
                            <TextField id="idsearchtxt"
                                defaultValue=""
                                value={this.state.searchtxt}
                                label={t("Patient.Medication.Search")}
                                onChange={this.onSearchChange}
                                fullWidth
                                inputProps={{
                                    autocomplete: 'new-password',
                                    form: {
                                        autocomplete: 'off',
                                    },
                                }}
                                variant="standard"/>
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            &nbsp;
                        </Grid>
                        <Grid item xs={6} sm={4} style={{ display: "flex", alignItems: 'center', justifyContent: 'end', paddingRight: '1.5rem' }}>
                            {isSyncInProgress === true ? (<img src={smallSpinner} height={36} width={36} style={{ marginRight: '2%', marginTop: '3%'}} alt="sync"/>) : ('')}
                            <Button
                                disabled={isSyncInProgress}
                                onClick={this.syncWithThirdParty}
                                color="primary"
                                className={classes.primaryButton}
                                sx={{mt: '3%'}}>
                                {t("Patient.Medication.SyncRecord")}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={4} style={{ paddingTop: '20px', color: 'red' }}>
                            {error}
                        </Grid>
                    </Grid>
                </div>
                <Divider style={{marginTop:'20px',height:'5px', borderColor:'rgba(0, 0, 0, 0.12)',borderStyle: 'solid', borderBottomWidth: '5px' }}/>
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                        />
                        <TableBody>
                            {!data ?
                                (<TableRow>
                                    <TableCell colSpan={7} style={{ textAlign: "center", padding: '10px 0px' }}>
                                        {this.state.isDataEmpty && t("Patient.Medication.NoDataFound")}
                                    </TableCell>
                                </TableRow>) : stableSort(data, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map(n => {
                                        return (
                                            <TableRow>
                                                <TableCell className={classes.padding10px} >{n.firstname}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.lastname}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.store}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.box}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.binid}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.rxno}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.ndccode}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                        </TableBody>
                    </Table>
                </div>
                <ThemeProvider theme={localeTheme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data ? data.length : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page"
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

PatientMadicationHistory.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(PatientMadicationHistory));



// WEBPACK FOOTER //
// ./src/components/patient-list/patient-madication-history.js